import { render, staticRenderFns } from "./ThingPage.vue?vue&type=template&id=edcb18c2&scoped=true&"
import script from "./ThingPage.vue?vue&type=script&lang=js&"
export * from "./ThingPage.vue?vue&type=script&lang=js&"
import style0 from "./ThingPage.vue?vue&type=style&index=0&id=edcb18c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcb18c2",
  null
  
)

export default component.exports